import { isObjWithKeys } from '../../../../../../utilities/objectHelper';

export const addZeroesAndGetWebRate = (tfw: any, Month: string) => {
  if (isObjWithKeys(tfw)) {
    const {
      web_rate: webRate,
      move_in: { web_rate: moveInWebRate = 0 } = {},
    } = tfw;
    const tfwWebRate = (webRate || moveInWebRate).toString();
    return Number(tfwWebRate).toFixed(
      Math.max(
        (typeof tfwWebRate === 'string' ? tfwWebRate.split('.') : '')[1]
          ?.length,
        2
      ) || 2
    );
  }
  return Month;
};
